// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class RouteViolationLevelRecord extends VerofreshRecord {
  static get endpoint () { return 'route-violation/levels' }
}

export default RouteViolationLevelRecord
